import * as React from 'react';
import { SVGProps } from 'react';

const IconRouteSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m6.144 4.188-.71-.708L3.3 5.605a1 1 0 0 0 0 1.417c.393.392 1.03.392 1.422 0l2.845-2.834a2.016 2.016 0 0 1 2.844 0 1.999 1.999 0 0 1 0 2.834L9.183 8.246a2.521 2.521 0 0 0-.68-.74L9.7 6.314a1 1 0 0 0 0-1.417 1.008 1.008 0 0 0-1.422 0L5.433 7.73a2.016 2.016 0 0 1-2.844 0 1.999 1.999 0 0 1 0-2.834L4.722 2.77l-.71-.708L7.211 1 6.143 4.188Z" />
    <path d="M8.499 9.497c0-.83-.676-1.503-1.509-1.503-.833 0-1.508.673-1.508 1.503 0 .83.675 1.503 1.508 1.503S8.5 10.327 8.5 9.497Z" />
  </svg>
);
export default IconRouteSizeXs;
